import { Media, useCustomQuery } from '@gripp/shared-logic';
import { StyleSheet } from 'react-native';
import { Card } from 'react-native-paper';
import { ImageComponent } from './imageComponent';
import { ImageData } from './types';
import { useTypedMediaItem } from './useTypedMediaItem';

export const GetImageMediaComponent: React.FC<{
  media: Media;
  children?: React.ReactNode;
  isAlignLeft?: boolean;
}> = (props) => {
  const { data } = useCustomQuery({
    cacheKey: ['getMedia', props.media.id],
    query: GET_MEDIA,
    variables: {
      getMediaId: props.media.id,
    },
    options: {
      gcTime: 10000,
      staleTime: 10000,
    },
  });
  const { typedMediaItem: image } = useTypedMediaItem<ImageData>(
    data?.getMedia
  );

  if (!props?.media.id || !image || !data) return null;

  return (
    <Card
      style={[
        styles.imageCard,
        {
          height: 150 + 1,
          width: 150,
          marginHorizontal: props.isAlignLeft ? undefined : 'auto',
        },
      ]}
    >
      <ImageComponent
        mediaItem={image}
        displayWidth={150}
        hasLightbox
        displayMode="card"
      />
      {props?.children}
    </Card>
  );
};

const GET_MEDIA = `
  query GetMedia($getMediaId: ID!) {
    getMedia(id: $getMediaId) {
      createdAt
      updatedAt
      id
      name
      status
      type
      updatedBy {
        id
        email
      }
      extension
    }
  }
`;

const styles = StyleSheet.create({
  imageCard: {
    borderRadius: 8,
    position: 'relative',
    marginBottom: 20,
  },
});
